import React from "react";
import {Switch, Route} from 'react-router-dom';
import {
    ROUTE_ADMIN_CAMPAIGN,
    ROUTE_ADMIN_FILE_MANAGEMENT,
    ROUTE_ADMIN_WORKSHOPS,
    ROUTE_CONTRACT_DATA,
    ROUTE_ENTRY_CHANNEL,
    ROUTE_EXCEPTIONS,
    ROUTE_EXTERNAL_USERS,
    ROUTE_INTERACTION,
    ROUTE_MAIL_MAPPERS,
    ROUTE_SERVICES,
    ROUTE_STATES,
    ROUTE_SUBSTATES,
    ROUTE_TAXONOMIES,
    ROUTE_TEMPLATES,
    ROUTE_USERS,
    ROUTE_SUPPLIER,
    ROUTE_SUPPLIER_SERVICE_TYPE,
    ROUTE_CUSTOMER,
} from "../routes/routesConstants";
import StatesManagement from "./StatesManagement";
import EntryChannelManagement from "./EntryChannelManagement";
import InteractionManagement from "./InteractionManagement";
import TaxonomyManagement from "./TaxonomyManagement";
import UserManagement from "./UserManagement";
import { SubStatesManagement } from "./SubStatesManagement";
import ExceptionManagement from "./ExceptionsManagement";
import ContractDataManager from "./ContractDataManagement";
import TemplatesManagement from "./TemplatesManagement";
import {ExternalUserManagement} from "./ExternalUserManagement";
import WorkshopManagement from "./WorkshopManagement";
import { FileManagement } from "./FileManagement";
import { CampaignManagement } from "./campaigns/CampaignManagemente";
import { PrivateRoute } from "./PrivateRoute";
import { ADMIN, MANAGER, FINANCIAL_ADMIN } from "../../Constantes/userRoles";
import MailMapperManager from "./MailMapperManagement";
import ServiceManagement from "./ServiceManagement";
import SupplierManagement from "./SupplierManagement";
import SupplierServiceTypeManagement from "./SupplierServiceTypeManagement";
import CustomerManagement from "./CustomerManagement";

const AdminWrapper = () => {
    return(
        <div style={{ marginTop: "1.5625rem" }}>
            <Switch>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_STATES} component={StatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_SUBSTATES}  component={SubStatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_ENTRY_CHANNEL} component = { EntryChannelManagement }/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_INTERACTION} component = { InteractionManagement }/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_TAXONOMIES} component = { TaxonomyManagement } />
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_USERS} component = { UserManagement } />
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_EXCEPTIONS} component = {ExceptionManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path = {ROUTE_CONTRACT_DATA} component = {ContractDataManager}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_TEMPLATES} component = {TemplatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_EXTERNAL_USERS} component = {ExternalUserManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_ADMIN_WORKSHOPS} component = {WorkshopManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_ADMIN_FILE_MANAGEMENT} component = {FileManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]}  path={ROUTE_ADMIN_CAMPAIGN} component = {CampaignManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]} path={ROUTE_MAIL_MAPPERS} component = {MailMapperManager}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]} path={ROUTE_SERVICES} component = {ServiceManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]} path={ROUTE_SUPPLIER} component = {SupplierManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]} path={ROUTE_SUPPLIER_SERVICE_TYPE} component = {SupplierServiceTypeManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, FINANCIAL_ADMIN]} path={ROUTE_CUSTOMER} component = {CustomerManagement}/>
            </Switch>
        </div>
    )
}

export { AdminWrapper }